<span class="odometer" aria-live="polite">
  <span class="tw-sr-only">{{ ariaLabel() }}</span>
  @if (reducedMotion()) {
    <span
      class="odometer__crossfade"
      [class.odometer__crossfade--pulse]="crossFadePulse()"
      aria-hidden="true"
      >{{ ariaLabel() }}</span
    >
  } @else {
    @for (col of renderColumns(); track col.key) {
      @if (col.kind === "separator") {
        <span class="odometer__sep" aria-hidden="true">{{ col.char }}</span>
      } @else {
        <span
          class="odometer__digit"
          [class.odometer__digit--exiting]="col.exiting"
          [style.transition-delay.ms]="col.exitDelayMs"
          [style.transition-duration.ms]="col.exitDurationMs"
          aria-hidden="true"
        >
          <span
            class="odometer__strip"
            [class.odometer__strip--no-transition]="col.disableTransition"
            [style.transition-delay.ms]="col.delayMs"
            [style.transition-duration.ms]="col.durationMs"
            [style.transform]="col.translate"
          >
            @for (d of digitStrip; track $index) {
              <span class="odometer__row">{{ d }}</span>
            }
          </span>
        </span>
      }
    }
  }
</span>
